import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Input } from '@angular/core';
import { Chart } from 'chart.js';

@Component({
  selector: 'app-radarr-chart2',
  templateUrl: './radar-chart.component.html',
  styleUrls: ['./radar-chart.component.scss']
})
export class RadarChartComponent implements AfterViewInit   {
  chart: any;
  @Input() idElement = 'unknow';
  @Input() chartTitle = 'unknow';
  showPanelProperties =  false; // propiedad permite visualizar sidebar
  cardMaximized = false; // indica el estado de la card del chart

  @Input() positionLegend: any =  {label: 'Arriba', code: 'top'}; // posicion de la leyenda
  @Input() AdditionalColorCard = "" ;

  positionLegendList = [
  {label: 'Arriba', code: 'top'},
  {label: 'Izquierda', code: 'left'},
  {label: 'Abajo', code: 'bottom'},
  {label: 'Derecha', code: 'right'}];

  constructor() { }

  ngAfterViewInit(): void {
    this.generateChart();
  }
  generateChart() {
    this.chart = new Chart(this.idElement, {
      type: 'radar',
      data: {
        labels: ["Eating", "Drinking", "Sleeping", "Designing", "Coding", "Cycling", "Running"],
        datasets: [
            {
                label: "My First dataset",
                backgroundColor: "rgba(179,181,198,0.2)",
                borderColor: "rgba(179,181,198,1)",
                pointBackgroundColor: "rgba(179,181,198,1)",
                pointBorderColor: "#fff",
                pointHoverBackgroundColor: "#fff",
                pointHoverBorderColor: "rgba(179,181,198,1)",
                data: [65, 59, 90, 81, 56, 55, 40]
            },
            {
                label: "My Second dataset",
                backgroundColor: "rgba(255,99,132,0.2)",
                borderColor: "rgba(255,99,132,1)",
                pointBackgroundColor: "rgba(255,99,132,1)",
                pointBorderColor: "#fff",
                pointHoverBackgroundColor: "#fff",
                pointHoverBorderColor: "rgba(255,99,132,1)",
                data: [28, 48, 40, 19, 96, 27, 100]
            }
        ]
    },
      options: {
        legend: {
          display: true,
          position: this.positionLegend.code
        },
        scale: {
            angleLines: {
                display: false
            },
            ticks: {
                suggestedMin: 50,
                suggestedMax: 100
            }
        }
      }
    })
  }

  getStateCard(e) {
    this.cardMaximized = e;
  }

  onApplyChanges() {
    this.chart.destroy();
    this.generateChart();
   // this.showPanelProperties = false;
  }

}
